import type { SVGProps } from "react";
import { memo } from "react";
const IQ = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#2E27AD" />
        <stop offset="100%" stopColor="#527FFF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m32.455 47.864 1.271 1.544-9.717 8.005-6.252-4.59 1.183-1.612 4.998 3.669zM19.427 20.461A6.47 6.47 0 0 1 25.888 14a6.47 6.47 0 0 1 6.461 6.461 6.47 6.47 0 0 1-6.461 6.462 6.47 6.47 0 0 1-6.461-6.462m6.776 8.463c.044-.006 3.805-.143 7.241 2.482l1.213-1.59a14 14 0 0 0-4.258-2.209c2.368-1.501 3.95-4.139 3.95-7.146 0-4.665-3.796-8.461-8.461-8.461s-8.461 3.796-8.461 8.461c0 3.057 1.634 5.732 4.07 7.219-9.279 2.98-9.496 13.676-9.497 13.799l2 .019c.006-.499.281-12.221 12.203-12.574m11.634 30.084V45.433c3.034-2.473 6.77-3.841 10.618-3.841 3.142 0 6.22.893 8.901 2.584 4.98 3.138 8.171 8.755 8.489 14.832zm-23.763-.466V45.976l10.882-6.282 10.881 6.282v12.566l-10.881 6.282zm24.733-28.629c0-5.337 4.342-9.679 9.679-9.679 5.336 0 9.678 4.342 9.678 9.679s-4.342 9.679-9.678 9.679-9.679-4.342-9.679-9.679m29.064 30.095c0-7.137-3.62-13.852-9.448-17.524a18.8 18.8 0 0 0-4.726-2.135c3.827-1.919 6.467-5.871 6.467-10.436 0-6.44-5.238-11.679-11.678-11.679s-11.679 5.239-11.679 11.679c0 4.56 2.633 8.508 6.454 10.43a19 19 0 0 0-6.836 3.663l-11.469-6.622-12.882 7.438v14.874l12.882 7.438 10.609-6.126h32.306z"
      />
    </g>
  </svg>
);
const Memo = memo(IQ);
export default Memo;
